<div class="rs-review-business-type" *ngIf="serviceType">
  <div class="rs-review-step">{{'review.service-type' | translate}}</div>
  <div *ngIf="serviceType" class="rs-review-value">{{serviceType}}</div>
</div>
